<h1 class="h1-presentation">Présentation de l'équipe</h1>

<div *ngFor="let profil of profils" class="container-lg ht-grid profil px-3">
    <div class="h2-3">
        <h2 class="profil-h2">{{ profil.name }}</h2>
        <h3 class="profil-h3 d-none">{{ profil.title }}</h3>
    </div>
    <div class="profil-imgbtn">
        <img src="{{ profil.pathImg }}" alt="photo de profil" class="img-profil img-thumbnail shadow-sm">
        <a routerLink="/reservation" class="link-vers-reservation d-none">
            <button type="button" class="btn btn-block">
                Prendre rendez-vous
            </button>
        </a>
    </div>
    <div class="accordion" id="accordion{{ profil.id }}">
        <div class="accordion-item">
            <h3 class="accordion-header" id="heading{{ profil.id }}">
                <button class="accordion-button collapsed"
                        type="button" data-bs-toggle="collapse"
                        [attr.data-bs-target]="'#collapse' + profil.id"
                        aria-expanded="false" aria-controls="collapse{{ profil.id }}">
                    {{ profil.title }}
                </button>
            </h3>
            <div id="collapse{{ profil.id }}" class="accordion-collapse collapse" aria-labelledby="heading{{ profil.id }}" data-bs-parent="#accordion{{ profil.id }}">
                <div class="accordion-body" [innerHTML]="profil.content"></div>
                <a routerLink="/reservation" class="link-vers-reservation">
                    <button type="button" class="btn btn-block">
                        Prendre rendez-vous
                    </button>
                </a>
            </div>
        </div>
    </div>
    <div class="profil-content d-none" [innerHTML]="profil.content"></div>
</div>
